import { render, staticRenderFns } from "./session-summary.vue?vue&type=template&id=13697023&scoped=true&"
import script from "./session-summary.vue?vue&type=script&lang=js&"
export * from "./session-summary.vue?vue&type=script&lang=js&"
import style0 from "./session-summary.vue?vue&type=style&index=0&id=13697023&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13697023",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
